var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"400px"}},[_c('v-card',{staticClass:"mx-auto ma-15 pa-10 text-center",attrs:{"max-width":"1200"}},[_c('div',{staticClass:"text-h3"},[_vm._v(" YOU NEED A LICENCE FOR ACCESS")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }